export const SvgRedExclamtion = () => {
	return (
		<svg
			width="15"
			height="15"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.6883 11.2485L9.38956 1.50801C8.53822 0.0747792 6.46292 0.0728749 5.61044 1.50801L0.31192 11.2485C-0.558373 12.713 0.49529 14.5676 2.20104 14.5676H12.7988C14.5031 14.5676 15.5586 12.7145 14.6883 11.2485ZM7.5 12.8098C7.01549 12.8098 6.62109 12.4154 6.62109 11.9309C6.62109 11.4464 7.01549 11.052 7.5 11.052C7.98451 11.052 8.3789 11.4464 8.3789 11.9309C8.3789 12.4154 7.98451 12.8098 7.5 12.8098ZM8.3789 9.29415C8.3789 9.77867 7.98451 10.1731 7.5 10.1731C7.01549 10.1731 6.62109 9.77867 6.62109 9.29415V4.89962C6.62109 4.41511 7.01549 4.02072 7.5 4.02072C7.98451 4.02072 8.3789 4.41511 8.3789 4.89962V9.29415Z"
				fill="#FA4B4B"
			/>
		</svg>
	);
};
